export default {
    namespaced: true,
    state: {
        ratingReady: false,
    },
    mutations: {
        set_rating_state(state, ratingReady) {
            state.ratingReady = ratingReady
        }
    },
    actions: {
        SET_RATING_STATE({commit}, ratingReady) {
            commit('set_rating_state', ratingReady)
        },
        RESET_RATING_STATES(context) {
            context.state.ratingReady = false
        }
    },
    getters: {
        get_rating_state: state => !!state.ratingReady
    }
}